<template lang='pug'>
  v-container.px-3.collaborators-container(fluid)
    //- Restrictions
    v-dialog( persistent  :value='validatorRestrictions'  max-width='500px')
      validate-restrictions(:data="dataValidator" @close="validatorRestrictions=false")
    v-dialog( persistent  :value='validatorRestrictionsStatus'  max-width='500px')
      validate-restrictions(:data="dataValidatorStatus" @close="validatorRestrictionsStatus=false")
    //- Create
    v-dialog(v-if="createItemDialog" persistent  :value='createItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      create-item( @close="createItemDialog=false; validRestrictions()" v-if='createItemDialog' )
    //- Update
    v-dialog(v-if="updateItemDialog" persistent :key='currentItemId' :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      update-item(:model ='currentItem' @close="updateItemDialog=false")
    //- Delete
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card
        v-card-title
          | Eliminar Colaborador
          v-spacer
            v-icon(aria-label="Close" @click="$emit('close')")
              | mdi-close
        v-card-text.body-1.text-center
          | ¿Esta seguro de eliminar este colaboraodor?
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
            v-btn(color='red darken-1', flat='', @click.native='deleteItem(currentItemId)') Si, proceder
    //- Metrics
    v-dialog(v-if="metricsDialog" v-model='metricsDialog' max-width="800" persistent)
      v-card
        v-card-title.dialog-card-title
          p Metricas del Colaborador
          v-icon(color="white" aria-label="Close" @click="metricsDialog = false") mdi-close
        v-card-text.body-1.mt-2
          v-row.my-1.justify-space-between.align-center
            //- Dates
            v-col.px-0(cols="6" xs="6" sm="6" md="6")
              p(style="font-size: 15px") {{from === '' ? 'Ventas realizadas en 7 días' : 'Ventas desde ' + from + ' hasta ' + to + ''}}
            //- Filter date
            v-col.d-flex.justify-end.px-0(cols="6" xs="6" sm="6" md="6")
              v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
                template(v-slot:activator='{ on }')
                  v-btn.main-btn-gradient(color='#3cbbc2', dark small v-on='on' style="height: 48px;").mt-0
                    v-icon mdi-calendar
                    p filtrar
                v-card(style="border:3px solid #3cbbc2;").pa-2
                  date-filter(@closeMenu="filterSummary($event)" :currentType='currentType',)
          p En total realizó {{totalAmountSalesCollabs}} ventas {{'( ' + numberFormat(totalMoneySalesCollab) + ' )'}}. Total en comisiones {{'( ' + numberFormat(totalComissionSalesCollab) + ' )'}}
          v-skeleton-loader.mx-auto(:transition='transition' type='card' v-if='loading')
          LineChart(v-else :chart-data='collaboratorData' :options="optionsCharts")
    //- Content
    v-row.px-5.my-0
      v-card.rounded-lg.pa-3( width="100%")
        v-row
          v-col.pb-0(cols="6" xs="6" sm="6" md="4")
            v-card-title Colaboradores
          v-col.pb-0.d-flex.create-btn(cols="6" xs="6" sm="6" md="8")
            v-btn.main-btn-gradient(small @click="createItemDialog = true" style="height: 48px;").mt-0
              v-icon mdi-plus
              | Agregar Colaborador
        v-row
          v-col(cols='12' md='12')
            .card-transactions
              .show-table-desktop
                v-data-table.elevation-0(v-if="!isMobile" :headers='headers', :items='Items', :search='search')
                  template(v-slot:item.actions="{ item }")
                    v-btn(fab dark text small color='green' @click.stop='editItem(item.id)')
                      v-icon(small) mdi-pen
                    v-btn(fab dark text small color='red'  @click.stop='openDeleteDialog(item)')
                      v-icon(small) mdi-delete
                    v-btn(fab dark text small color='primary'  @click.stop='openMetricsDialog(item.id)')
                      v-icon(small) mdi-poll
              .show-table-mobile
                v-list(three-line="")
                  template(v-for="(item, index) in Items")
                    v-list-item(:key="item.id" @click="showItem(item)")
                      v-list-item-avatar
                        v-img(:src="getImage(item.pictures && item.pictures.imageInput1 ? item.pictures.imageInput1 : '')" max-width="160px")
                      v-list-item-content
                        v-list-item-title(v-html="item.displayName")
                        v-list-item-subtitle(v-html="item.role")
                    v-divider
                noResults(v-if="Items.length === 0" :title="'No tienes proveedores'" :description="'En esta sección encontraras tus proveedores'")
    //- old Content
    //- v-layout(wrap='')
      v-flex(md12='')
        v-card
          v-card-title
            span Colaboradores
            v-row
              v-col(:cols="isMobile ? '12' : '4'" :sm="isMobile ? '12' : '4'").text-right
                v-card(style='margin: 2px;' flat link @click="createItemDialog = true" height="20" outlined  @focus="blur()" :class="banCreateColaborator ? 'disabled' : ''").category-card.py-5.mx-2
                  v-layout(pa-1 pl-2).text-center
                    v-layout(xs12='' style="z-index: 0;").justify-space-around.align-center
                      small.text-uppercase.text-center(style="width: 350px;") crear colaborador
                        v-icon(large color="primary") mdi-plus
          v-flex(md12='',)
            v-row
              v-col
                | Lista de colaboradores
              v-col
                v-spacer
              v-text-field(v-model='search', append-outer-icon='mdi-search', label='Buscar..', single-line='', hide-details='')
            v-card.mx-auto(v-if="isMobile && Items.length > 0" max-width="450")
              v-list(three-line="")
                template(v-for="(item, index) in Items")
                  v-list-item(:key="item.id" @click="showItem(item)")
                    v-list-item-avatar
                      v-img(:src="getImage(item.pictures && item.pictures.imageInput1 ? item.pictures.imageInput1 : '')" max-width="160px")
                    v-list-item-content
                      v-list-item-title(v-html="item.displayName")
                      v-list-item-subtitle(v-html="item.role")
                  v-divider
            noResults(v-if="isMobile && Items.length === 0" :title="'No tienes proveedores'" :description="'En esta sección encontraras tus proveedores'")
            v-data-table(v-if="!isMobile" :headers='headers', :items='Items', :search='search')
              template
                v-card-text
              template(v-slot:item.actions="{ item }")
                v-btn(fab dark small color='green' @click.stop='editItem(item.id)')
                  v-icon(small) mdi-pen
                v-btn(fab dark small color='red'  @click.stop='openDeleteDialog(item)')
                  v-icon(small) mdi-delete
                v-btn(fab dark small color='primary'  @click.stop='openMetricsDialog(item.id)')
                  v-icon(small) mdi-poll
</template>

<script>

  import Swal from 'sweetalert2'
  import loaders from '@/plugins/mixins/loaders'
  import CreateItem from './CreateUser'
  import UpdateItem from './UpdateUser'
  import moment from 'moment'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import LineChart from '@/components/custom/charts/LineChart'
  import userPlaceholder from '@/assets/user.png'

  export default {
    components: {
      LineChart,
      DateFilter: DateFilter,
      CreateItem: CreateItem,
      UpdateItem: UpdateItem,
      ValidateRestrictions: () => import('@/views/pages/components/ValidateRestrictions'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    mixins: [loaders],
    data () {
      return {
        userPlaceholder,
        banCreateColaborator: false,
        totalAmountSalesCollabs: 0,
        loading: false,
        dataValidator: {
          title: this.$t('shop.createModule.titleValiadtorCollaborator'),
          message: this.$t('shop.createModule.messageValidatorCollaborator'),
        },
        dataValidatorStatus: {
          title: this.$t('shop.createModule.titleValiadtorShopStatus'),
          message: this.$t('shop.createModule.messageValidatorShopStatus'),
        },
        collaboratorData: {
          labels: [],
          datasets: [],
        },
        totalMoneySalesCollab: 0,
        totalComissionSalesCollab: 0,
        validatorRestrictions: false,
        validatorRestrictionsStatus: false,
        collaboratorsRestriction: null,
        status: null,
        totalShops: 0,
        search: '',
        createItemDialog: false,
        updateItemDialog: false,
        confirmationDialog: false,
        metricsDialog: false,
        menu: false,
        currentType: 'loadFilteredSummary',
        from: '',
        to: '',
        transition: 'scale-transition',
        currentItemId: '',
        headers: [

          {
            sortable: true,
            text: 'Nombre',
            value: 'displayName',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Rol',
            value: 'role',
            align: 'left',

          },
          {
            sortable: true,
            text: 'Email',
            value: 'email',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Actions',
            value: 'actions',
            align: 'left',
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      Items () {
        return this.$store.getters['admins/getItems']
      },
      currentItem () {
        // console.log(this.$store.getters['admins/getCurrentItem'])
        return this.$store.getters['admins/getCurrentItem']
      },
      totalCollaborators () {
        return this.$store.getters['admins/getItems'].length
      },
      optionsCharts () {
        const vm = this
        return {
          tooltips: {
            mode: 'label',
            callbacks: {
              label: function (tooltipItem, data) {
                // console.log(tooltipItem, data)
                return data.labels[tooltipItem.index] + ': ' + vm.numberFormat(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])
              },
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
    },
    mounted () {
      this.validRestrictions()
    },
    created () {
      const vm = this
      vm.loadAdmins()
    },
    methods: {
      numberFormat (val) {
        if (val || val === 0) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '$0 '
      },
      getImage (url) {
        if (url === '') {
          return userPlaceholder
        } else {
          return url
        }
      },
      showItem (item) {
        const vm = this
        vm.$router.replace('/dashboard/userDetails/collaborator')
        this.$store.dispatch('admins/setCurrentItem', { context: 'properties', id: item.id }).then(function () {
        })
      },
      async filterSummary (dates) {
        const vm = this
        let preset = 'week'
        if (dates) {
          vm.menu = false
          vm.from = moment(dates.from).format('DD-MM-YYYY')
          vm.to = moment(dates.to).format('DD-MM-YYYY')
          const momentFrom = moment(dates.from)
          const momentTo = moment(dates.to)
          const differenceInDays = momentTo.diff(momentFrom, 'days')
          // este preset es para los labels. No es para calcular fechas
          if (differenceInDays === 1) {
            preset = 'today'
          } else if (differenceInDays <= 7) {
            preset = 'week'
          } else if (differenceInDays <= 31) {
            preset = 'month'
          } else {
            preset = 'year'
          }
        } else {
          vm.from = ''
          vm.to = ''
        }
        vm.getCollaboratorsMetrics(dates, preset)
      },
      getCollaboratorsMetrics (dates, preset) {
        const vm = this
        vm.loading = true
        const collabs = {
          dates: dates,
          userId: this.$store.state.users.user.uid,
          shopId: '',
          colabId: vm.currentItemId,
          preset: preset,
        }
        this.$store.dispatch('summary/summaryByCollaborator', collabs).then(res => {
          if (res.data.collaborators.length > 0) {
            vm.collaboratorData.labels = Object.keys(res.data.resultsCost[0])
            vm.totalAmountSalesCollabs = res.data.amountSales
            vm.totalMoneySalesCollab = Object.values(res.data.resultsCost[0]).reduce((a, b) => a + b, 0)
            vm.totalComissionSalesCollab = res.data.totalComission
            vm.collaboratorData.datasets = []
            const collaborator = res.data.collaborators[0]
            // console.log(collaborator)
            const sales = res.data.resultsCost[0]
            const comissions = res.data.resultsCostComissions ? res.data.resultsCostComissions[0] : 0
            // console.log(sales)
            vm.collaboratorData.datasets.push({
              label: collaborator.email,
              data: Object.values(sales),
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
            })
            vm.collaboratorData.datasets.push({
              label: 'Comisiones',
              data: Object.values(comissions),
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
            })
            // console.log(vm.collaboratorData.datasets)
            vm.$forceUpdate()
          } else {
            vm.collaboratorData.labels = []
            vm.collaboratorData.datasets = []
          }
          vm.loading = false
        })
      },
      /* validCreateUser () {
        const vm = this
        this.$store.dispatch('users/getRestrictions').then(res => {
          // console.log(res)
          if (res) {
            vm.collaboratorsRestriction = res.restrictions.collaborators
            vm.status = res.status.val
            if (vm.status !== 'active') {
              vm.validatorRestrictionsStatus = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction === null) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction <= vm.totalCollaborators) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
              return
            }
          } else {
            vm.validatorRestrictionsStatus = true
            vm.banCreateColaborator = true
            return
          }
          this.createItemDialog = true
        })
      }, */
      openMetricsDialog (id) {
        const vm = this
        vm.currentItemId = id
        vm.metricsDialog = true
        vm.getCollaboratorsMetrics(null, 'week')
      },
      openDeleteDialog (item) {
        // console.log(item)
        const vm = this
        vm.currentItemId = item
        Swal.fire({
          title: 'Eliminar colaborador',
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteItem(vm.currentItemId)
          }
        })
        // vm.confirmationDialog = true
      },
      editItem (id) {
        const vm = this
        this.$store.dispatch('admins/setCurrentItem', { context: 'properties', id: id }).then(function () {
          vm.updateItemDialog = true
        })
      },
      validRestrictions () {
        const vm = this
        vm.$store.dispatch('users/getRestrictions').then(res => {
          // console.log(res)
          if (res) {
            vm.collaboratorsRestriction = res.restrictions.collaborators
            vm.status = res.status.val
            if (vm.status !== 'active') {
              vm.validatorRestrictionsStatus = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction === null) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
              return
            }
            if (vm.collaboratorsRestriction <= vm.totalCollaborators) {
              vm.validatorRestrictions = true
              vm.banCreateColaborator = true
              return
            }
          } else {
            vm.validatorRestrictionsStatus = true
            vm.banCreateColaborator = true
            return
          }
          vm.banCreateColaborator = false
        })
      },
      deleteItem (item) {
        // console.log(item)
        const vm = this
        vm.$store.dispatch('admins/deleteItem', item)
          .then(function () {
            vm.confirmationDialog = false
            vm.dialog = false
            vm.validRestrictions()
          },
          ).catch(function () {
            vm.confirmationDialog = false
            vm.dialog = false
            vm.validRestrictions()
          })
      },
    },
  }
</script>
<style lang="scss">
  .collaborators-container{
    .create-btn{
      justify-content: center;
    }
    @media(min-width: 600px) {
      .create-btn{
        justify-content: end !important;
      }
    }
    .card-transactions{

      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    @media(min-width: 760px) {
      .show-table-mobile{
        display: none !important;
      }
      .show-table-desktop{
        display: block !important;
      }
    }
    @media(max-width: 1100px) {
      .show-table-mobile{
        display: flex !important;
      }
      .show-table-desktop{
        display: none !important;
      }
    }
    .hover-cursor{
      cursor:pointer;
    }
    /* Adding cursor just works: */
    .disabled {
        cursor: not-allowed;
    }

    /* Makes link non-clickable: */
    .disabled:active {
        pointer-events: none;
    }
  }
</style>
